// extracted by mini-css-extract-plugin
module.exports = {"title":"search_facets_lib-module__title--2WP94"};